export default __webpack_public_path__ + "static/media/host-annual-plan.f9eec030.png";